/*
 * 文件EN: merchantAudit.js,
 * 文件CN: 商户系统审核,
 * 创建时间: Wednesday, 29th April 2020 5:45:42 pm,
 * 创建人: CP-Mac,
 * 联系邮箱: you@you.you,
 */
import * as Models from '@/api/T3/merchantAudit'

export default {
  namespaced: true,
  state: {
    row: {},
    checkoutListData: []
  },
  getters: {
    row: state => state.row,
    checkoutListData: state => state.checkoutListData
  },
  mutations: {
    SET_ROW(state, data) {
      state.row = data
    },
    setCheckoutListData: (state, data) => {
      state.checkoutListData = data;
    }
  },
  actions: {
    row({ commit }, row) {
      commit('SET_ROW', row)
    },
    // 获取列表
    getList(ctx, payload) {
      return Models.getListData(payload).then(res => {
        return res && res.status === 200 ? res.data : {}
      })
    },
    // 转移发行/批量
    async transferIssueBatch(ctx, payload) {
      return await Models.transferIssueBatch(payload).then(res => {
        return (res.status === 200) && Promise.resolve(res) || Promise.reject(`data: ${null}`)
      })
    },
    // 提交审核 单个
    confirm(ctx, payload) {
      return Models.confirm(payload).then(res => {
        return res
      })
    },
    // 提交审核 批量
    confirmArr(ctx, payload) {
      return Models.confirmArr(payload).then(res => {
        return res
      })
    },
    // 第三方支付交易数据
    getThirdPayData(ctx, payload) {
      return Models.thirdPayData(payload).then(res => {
        return res && res.status === 200 && res.data || {}
      })
    },
    // 提交第三方支付数据统计审核
    getThirdPayStatistics(ctx, payload) {
      return Models.thirdPayStatistics(payload).then(res => {
        return res && res.status === 200 && res.data || {}
      })
    },
    // 第三方交易整体占比图
    getThirdPaymentFigure(ctx, payload) {
      return Models.thirdPaymentFigure(payload).then(res => {
        return res && res.status === 200 && res.data || {}
      })
    },
    // 外卖数据统计
    getTakeAwayStatistics(ctx, payload) {
      return Models.takeAwayStatistics(payload).then(res => {
        return res && res.status === 200 && res.data || {}
      })
    },
    // 外卖数据核定
    takeAwayDataApproval(ctx, payload) {
      return Models.takeAwayDataApproval(payload).then(res => {
        return res && res.status === 200 && res.data || []
      })
    },
    // 支出
    getDisburse(ctx, payload) {
      return Models.disburse(payload).then(res => {
        return res && res.status === 200 && res.data || {}
      })
    },
    // 经营总结
    getManagementForms(ctx, payload) {
      return Models.fetchManagementForms(payload).then(res => {
        return res && res.status === 200 && res.data || {}
      })
    },
    // 审核报告
    getAuditReport(ctx, payload) {
      return Models.fetchAuditReport(payload).then(res => {
        return res && res.status === 200 && res.data || {}
      })
    },
    // 新审核报告
    getResult(ctx, payload) {
      return Models.getResult(payload).then(res => {
        return res && res.status === 200 && res.data || {}
      })
    },
    // 特殊名单验证
    getFlagSpecialList(ctx, payload) {
      return Models.getFlagSpecialList(payload).then(res => {
        return res && res.status === 200 && res.data || {}
      })
    },
    // 借贷行为验证
    getTotalLoan(ctx, payload) {
      return Models.getTotalLoan(payload).then(res => {
        return res && res.status === 200 && res.data || {}
      })
    },
    getTotalLoanIdAndCell(ctx, payload) {
      return Models.getTotalLoanIdAndCell(payload).then(res => {
        return res && res.status === 200 && res.data || {}
      })
    },
    getInfoRelation(ctx, payload) {
      return Models.getInfoRelation(payload).then(res => {
        return res && res.status === 200 && res.data || {}
      })
    },

    // 审核报告导出
    getAuditReportExport(ctx, payload) {
      return Models.fetchAuditReportExport(payload).then(res => {
        return res && res.status === 200 && res.data || {}
      })
    },
    // 审核报告修改
    getAuditReportUpdate(ctx, payload) {
      return Models.auditReportUpdate(payload).then(res => {
        return res && res.status === 200 && res.data || {}
      })
    },
    // 负责人信息
    getPrincipalInfo(ctx, payload) {
      return Models.fetchPrincipalInfo(payload).then(res => {
        return res && res.status === 200 && res.data || []
      })
    },
    getRelationship(ctx, payload) {
      return Models.getRelationship(payload).then(res => {
        return res && res.status === 200 && res.data || []
      })
    },
    // 允许发送-是 查看建议额度
    async getViewAllowSend(ctx, payload) {
      const res = await Models.getViewAllowSend(payload)
      return res && res.status === 200 && res.data || {}
    },
    // 允许发送-是 修改建议额度
    async sendAllowSend(ctx, payload) {
      const res = await Models.sendAllowSend(payload)
      return res && res.status === 200 && res
    },
    // 商户系统审核 - 无额度通过转为有额度通过
    async sendWithQuota(ctx, payload) {
      const res = await Models.sendWithQuota(payload)
      return res && res.status === 200 && res
    },
    // 批量导出商户详情列表到EXCEL - 内容+图片
    async getExport(ctx, payload) {
      const res = await Models.getExport(payload)
      return res && res.status === 200 && res
    },

    // 关系验证-相关联系人列表
    listContacts(ctx, payload) {
      return Models.listContacts(payload).then(res => {
        return res && res.status === 200 && res.data || {}
      })
    },

    // 关系验证-相关法人列表
    listRelationCorps(ctx, payload) {
      return Models.listRelationCorps(payload).then(res => {
        return res && res.status === 200 && res.data || {}
      })
    },

    // 关系验证-相关地理信息列表
    listRelationGeographicInfo(ctx, payload) {
      return Models.listRelationGeographicInfo(payload).then(res => {
        return res && res.status === 200 && res.data || {}
      })
    },

    // 关系验证-用户匹配信息列表
    listUserMatchingInfor(ctx, payload) {
      return Models.listUserMatchingInfor(payload).then(res => {
        return res && res.status === 200 && res.data || {}
      })
    },

    // 关联分析-获取工商详细信息
    getBusinessDetailsInfo(ctx, payload) {
      return Models.getBusinessDetailsInfo(payload).then(res => {
        return res && res.status === 200 && res.data || {}
      })
    },

    // 关联分析-获取疑似关联信息
    getSuspectedAssociationInfo(ctx, payload) {
      return Models.getSuspectedAssociationInfo(payload).then(res => {
        return res && res.status === 200 && res.data || {}
      })
    },
  }
}